module.exports = __webpack_public_path__ + "static/img/banner6.1e05426.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepageComponent/images/banner6.jpg
// module id = KAnz
// module chunks = 6